import { type DashboardOverview, request } from '@/shared'

export const getDashboard = (year: number) => request<DashboardOverview>('get', `/dashboard?year=${year}`)
